import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import * as XLSX from 'xlsx'
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router } from '@angular/router';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
@Component({
  selector: 'app-importproduct',
  templateUrl: './importproduct.component.html',
  styleUrls: ['./importproduct.component.css']
})
export class ImportproductComponent implements OnInit {


  @Output() emitData = new EventEmitter();

  showProgress: boolean = false;


  constructor(private appService: DhukanDataService, public router: Router, private activeModal: NgbActiveModal,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService,
    private productFindService: NgbModal, public loginService: LoginDataService) { }

  excelColl: any = [];

  ngOnInit() {
  }
  onFileChange(event: any) {
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      //console.log(data); // Data will be logged in array format containing objects
      this.excelColl = data;

    };
  }



  fnSaveBtnClick() {

    let _dataColl = [];


    for (let row of this.excelColl) {
      var data = {
        barcode: row.barcode,
        itemname: row.itemname,
        itemcode: row.itemcode,
        group: row.group,
        foodsymbol: row.foodsymbol,
        uom: row.uom,
        taxname: row.taxname,
        taxrate: row.taxrate,
        cgsttaxrate: row.cgsttaxrate,
        sgsttaxrate: row.sgsttaxrate,
        igsttaxrate: row.igsttaxrate,
        price1: row.price1,
        price2: row.price2,
        price3: row.price3,
        cost: row.cost,
        isvariation: row.isvariation,
        sizename: row.sizename,
        inactive:0,
        modifiedby: this.loginService.fnGetModUserId(),
      }

      _dataColl.push(data)
    }

    this.fnInsertExcelImport(_dataColl)

  }


  fnInsertExcelImport(_dataColl) {
    this.fnShowProgress()
    var data = {
      doctype: 'importprod',
      companyid: this.loginService.fnGetCompanyId(),
      modifiedby: this.loginService.fnGetModUserId(),
      importdetailscoll: _dataColl,
    }

    this.appService.fnInsertProductImport(data).subscribe((res) => {
      this.fnHideProgress();
      //console.log(res.json());
      if (res.json().status === 200) {
        if (res.json().result === "DONE") {
          this.emitData.emit("DONE");
          this.activeModal.close(true);
        }
        else {          
          this.toastr.error('Error', "Invalid Company Code");

        }

      }
    },
      (err) => {
        this.fnHideProgress()
        this.toastr.error('Error', err);
      });
  }



  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }



  public decline() {
    this.activeModal.close(false);
  }

}


